import { recognizeSerialNumberCommand } from './recognizeSerialNumberCommand';

export const CommonCatalogService = {
  recognizeSerialNumberCommand,
};
